var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M288 136a24 24 0 0 0-24-24h-97.62a23.66 23.66 0 0 0-44.77 0H24a24 24 0 0 0 0 48h240a24 24 0 0 0 24-24zm328.4-23.93l-97.82.31a23.58 23.58 0 0 0-45 .14l-98 .31a23.55 23.55 0 0 0 .15 47.09l240.81-.77a23.54 23.54 0 0 0-.15-47.08zM472 237.65l-96.85-29.05a191.9 191.9 0 0 0-110.33 0L168 237.65V192h-48v64.05a32 32 0 0 0 32 32h45.4a179 179 0 0 0-53.33 110.24 16.14 16.14 0 0 0 16 17.71h16.25c8.34 0 14.76-6.58 15.68-14.87a130 130 0 0 1 53.67-91.38l32.92 32.93a32 32 0 0 0 22.63 9.37h37.49a32 32 0 0 0 22.63-9.37l32.92-32.93A130.06 130.06 0 0 1 448 401.13c.92 8.29 7.34 14.85 15.68 14.87h16.25a16.14 16.14 0 0 0 16-17.71 179 179 0 0 0-53.33-110.24H488a32 32 0 0 0 32-32V192h-48z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/drone.d82ce5948298b369ec3b4d0b8f2f5564.svg";
export { ForwardRef as ReactComponent };